module.exports = __webpack_public_path__ + "static/media/bars-white.461ef9da.svg";